/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import 'reflect-metadata';
import { Vertices } from '../vertices';

// direct a vertices to common uses based in show step flag
export function directVertices<T>(
    target: any,
    propertyKey: string,
    descriptor: TypedPropertyDescriptor<T>
) {
    const set = descriptor.set!;

    descriptor.set = function (value: T) {
        const clone: Vertices = value as Vertices;
        const { current_object } = clone;
        if (current_object && current_object.showSelectedSteps === false) {
            clone.Threeshold = 100;
        }

        set.call(this, value);
    };
}

// valid the Vertices with certain clausa in show selected flag
export function validVertices<T>(
    target: any,
    propertyKey: string,
    descriptor: TypedPropertyDescriptor<T>
) {
    const set = descriptor.set!;

    descriptor.set = function (value: T) {
        const clone: Vertices = value as Vertices;
        const { current_object } = clone;
        if (current_object && current_object.showStep === true) {
            clone.Threeshold = 100;
        }
        set.call(this, value);
    };
}
